/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    type TextType = 'url' | 'resourceUrl' | 'html';

    export function meevoTrustFilter($sce: ng.ISCEService): any {

        const filter = (text: string, textType: TextType = 'resourceUrl') => {

            switch (textType) {
                case 'url':
                    text = $sce.trustAsUrl(text);
                    break;
                case 'resourceUrl':
                    text = $sce.trustAsResourceUrl(text);
                    break;
                case 'html':
                    text = $sce.trustAsHtml(text);
                    break;
            }

            return text;
        };


        return filter;
    }

    meevoTrustFilter.$inject = ['$sce'];

    angular.module('meevo.components.filters')
        .filter('trust', meevoTrustFilter);
}
